import { isAxiosError } from './is-axios-error';
/**
 * Extracts and returns the statusCode from an api error, or null when not found
 *
 * ### Usage :
 * ```
 *   getApiErrorStatusCode( myError )
 * ```
 *
 */
export function getStatusCode(error) {
    if (!isAxiosError(error))
        return null;
    return error?.response?.status || null;
}
//# sourceMappingURL=get-status-code.js.map